<template>
  <v-container fill-height>
    <v-row>
      <v-col class="text-center">
        <v-icon
          x-large
        >fas fa-spinner fa-pulse</v-icon>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Spinner',
};
</script>

<style scoped>

</style>
